<template>
    <div>
        <div>
          <app-kpihome />
        </div>
    </div>
</template>

<script>

import KPIHome from '../../sscomponents/performance/KPIHome.vue';

export default {

    components: {
        'app-kpihome': KPIHome,
    },

    data() {
        return {
        }
    },

    methods: {
    },

    mounted() {
    }
}

</script>

<style scoped>
/* Ensure the container takes the full width and has no centering */
.container {
    margin: 0;
    padding: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start; /* Align items to the left */
}

/* Optional: Ensure body has no padding or margin that might affect alignment */
body {
    margin: 0;
    padding: 0;
}
</style>